(() => {
  // Prevent double-init if the section re-renders
  if (window.FF_FRAME_BUNDLE_INIT) return;
  window.FF_FRAME_BUNDLE_INIT = true;

  const norm = (s) =>
    String(s || "")
      .toLowerCase()
      .replace(/\(.*?\)/g, "")  // remove "(B1)" etc
      .replace(/[×]/g, "x")
      .replace(/\s+/g, "")
      .trim();

// Money formatting – use active Shopify Markets currency
function formatCents(cents) {
  const currency = window.Shopify?.currency?.active || "DKK";

  const locale =
    document.documentElement.lang ||
    navigator.language ||
    "en-US";

  try {
    let formatted = new Intl.NumberFormat(locale, {
      style: "currency",
      currency,
      currencyDisplay: "narrowSymbol",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(cents / 100);

    // Ens visning for danske, svenske og norske kroner
    if (["DKK", "SEK", "NOK"].includes(currency)) {
      formatted = formatted.replace(/kr\.?/i, "kr.");
    }

    return formatted;
  } catch {
    return `${(cents / 100).toFixed(2)} ${currency}`;
  }
}
  function findMainSectionFromEl(el) {
    return el?.closest?.('section[id^="MainProduct-"]') || el?.closest?.(".product") || document;
  }

  function getPickerFromSection(sectionEl) {
    return sectionEl.querySelector(".ff-frame-picker");
  }

  function getProductFormFromSection(sectionEl) {
    return sectionEl.querySelector("product-form form") || document.querySelector("product-form form");
  }

  function getSelectedVariantId(form) {
    const idInput = form.querySelector('input[name="id"]');
    return idInput ? Number(idInput.value) : null;
  }

  function getQuantity(form) {
    const qty = form.querySelector('input[name="quantity"]');
    return qty ? Math.max(1, Number(qty.value || 1)) : 1;
  }

  function getPosterVariantFromPicker(pickerEl, posterVariantId) {
    const variants = JSON.parse(pickerEl.dataset.ffProductVariants || "[]");
    return variants.find(v => Number(v.id) === Number(posterVariantId));
  }

  // --- Frame product cache ---
  const frameProductCache = new Map();

  async function fetchProductJson(handle) {
    if (!frameProductCache.has(handle)) {
      frameProductCache.set(
        handle,
        fetch(`/products/${handle}.js`, { headers: { Accept: "application/json" } }).then((res) => {
          if (!res.ok) throw new Error(`Kunne ikke hente ramme: ${handle}`);
          return res.json();
        })
      );
    }
    return frameProductCache.get(handle);
  }

  function findFrameVariantBySize(frameProduct, sizeValue) {
    const target = norm(sizeValue);
    return frameProduct.variants.find(v => norm(v.option1) === target);
  }

  async function updateFrameOptionLabelsWithPrice(sectionEl) {
  const pickerEl = getPickerFromSection(sectionEl);
  const form = getProductFormFromSection(sectionEl);
  if (!pickerEl || !form) return;

  const select = pickerEl.querySelector('select[name="ff_frame_select"]');
  if (!select) return;

  const posterVariantId = getSelectedVariantId(form);
  if (!posterVariantId) return;

  const posterVariant = getPosterVariantFromPicker(pickerEl, posterVariantId);
  if (!posterVariant) return;

  const sizeValue = posterVariant.option1;

  const handles = JSON.parse(pickerEl.dataset.ffFrameHandles || "{}");

  for (const opt of Array.from(select.options)) {
    const key = opt.value;

    // gem original tekst én gang
    if (!opt.dataset.baseLabel) {
  // hvis der allerede står (+xxx), så strip det fra
  opt.dataset.baseLabel = opt.textContent.trim().replace(/\s*\(\+.*?\)\s*$/, "");
}


    // "Ingen ramme" skal ikke have pris
    if (key === "none" || !handles[key]) {
      opt.textContent = opt.dataset.baseLabel;
      continue;
    }

    const frameHandle = handles[key];
    const frameProduct = await fetchProductJson(frameHandle);
    const frameVariant = findFrameVariantBySize(frameProduct, sizeValue);

    if (!frameVariant) {
      opt.textContent = opt.dataset.baseLabel;
      continue;
    }

    const framePrice = Number(frameVariant.price || 0);
    opt.textContent = `${opt.dataset.baseLabel} (+${formatCents(framePrice)})`;
  }
}


  // --- Update Dawn price field ---
  function updateDawnPriceDisplay(sectionEl, totalCents) {
    const priceRoot =
      sectionEl.querySelector(".product__info-wrapper .price") ||
      sectionEl.querySelector(".price");

    if (!priceRoot) return;

    const txt = formatCents(totalCents);

    const regular = priceRoot.querySelector(".price__regular .price-item--regular");
    const sale = priceRoot.querySelector(".price__sale .price-item--sale");
    const saleRegular = priceRoot.querySelector(".price__sale .price-item--regular");

    // Update visible numbers
    if (sale) sale.textContent = txt;
    if (saleRegular) saleRegular.textContent = txt;
    if (regular) regular.textContent = txt;
  }

  async function updateMainPriceFromSelection(sectionEl) {
    const pickerEl = getPickerFromSection(sectionEl);
    if (!pickerEl) return;

    const form = getProductFormFromSection(sectionEl);
    if (!form) return;

    const posterVariantId = getSelectedVariantId(form);
    if (!posterVariantId) return;

    const qty = getQuantity(form);

    const posterVariant = getPosterVariantFromPicker(pickerEl, posterVariantId);
    if (!posterVariant) return;

    const posterPrice = Number(posterVariant.price || 0) * qty;

    const select = pickerEl.querySelector('select[name="ff_frame_select"]');
    const frameKey = select ? select.value : "none";

    let framePrice = 0;

    if (frameKey && frameKey !== "none") {
      const handles = JSON.parse(pickerEl.dataset.ffFrameHandles || "{}");
      const frameHandle = handles[frameKey];

      if (frameHandle) {
        const frameProduct = await fetchProductJson(frameHandle);
        const frameVariant = findFrameVariantBySize(frameProduct, posterVariant.option1);
        if (frameVariant) framePrice = Number(frameVariant.price || 0) * qty;
      }
    }
    await updateFrameOptionLabelsWithPrice(sectionEl);
    updateDawnPriceDisplay(sectionEl, posterPrice + framePrice);
  }

  // --- Cart add (bundle) ---
  function getCartUI() {
    return document.querySelector("cart-drawer") || document.querySelector("cart-notification");
  }

  function getSectionIds(cartUI) {
    if (cartUI?.getSectionsToRender) return cartUI.getSectionsToRender().map(s => s.id);
    return ["cart-drawer", "cart-icon-bubble", "cart-notification"];
  }

  async function postAdd(payload) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(payload)
    });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
  }

  async function addBundleToCart({ sectionEl, frameHandle, frameLabel }) {
    const pickerEl = getPickerFromSection(sectionEl);
    const form = getProductFormFromSection(sectionEl);
    if (!pickerEl || !form) throw new Error("Kunne ikke finde produkt-form/picker.");

    const posterVariantId = getSelectedVariantId(form);
    if (!posterVariantId) throw new Error("Ingen plakat-variant valgt.");

    const qty = getQuantity(form);

    const posterVariant = getPosterVariantFromPicker(pickerEl, posterVariantId);
    if (!posterVariant) throw new Error("Kunne ikke finde plakat-variant data.");

    const frameProduct = await fetchProductJson(frameHandle);
    const frameVariant = findFrameVariantBySize(frameProduct, posterVariant.option1);

    if (!frameVariant) throw new Error(`Ingen ramme i samme størrelse (${posterVariant.option1}).`);
    if (!frameVariant.available) throw new Error(`Rammen er udsolgt i ${posterVariant.option1}.`);

    const cartUI = getCartUI();
    const sectionIds = getSectionIds(cartUI);

    const payload = {
      items: [
        { id: posterVariantId, quantity: qty, properties: { Bundle: "Print + frame", Size: posterVariant.option1 } },
        { id: frameVariant.id, quantity: qty, properties: { Bundle: "Print + frame", Frame: frameLabel, Size: posterVariant.option1 } }
      ],
      sections: sectionIds,
      sections_url: "/cart"
    };

    const data = await postAdd(payload);

    if (cartUI?.renderContents && data?.sections) {
      cartUI.renderContents(data);
      cartUI.classList?.remove("is-empty");
      cartUI.open?.();
      return;
    }

    window.location.href = "/cart";
  }

  // --- Live price updates (frame / size / qty) ---
  function schedulePriceUpdateFromEl(el) {
    const sectionEl = findMainSectionFromEl(el);
    // give Dawn a tick to update hidden variant id
    setTimeout(() => updateMainPriceFromSelection(sectionEl), 0);
  }

  document.addEventListener("change", (e) => {
    const t = e.target;
    if (!(t instanceof Element)) return;

    // Frame dropdown
    if (t.matches('select[name="ff_frame_select"]')) {
      schedulePriceUpdateFromEl(t);
      return;
    }

    // Variant changes (radio/select)
    if (t.matches('input[type="radio"], select')) {
      schedulePriceUpdateFromEl(t);
      return;
    }
  }, true);

  document.addEventListener("input", (e) => {
    const t = e.target;
    if (!(t instanceof HTMLInputElement)) return;
    if (t.name !== "quantity") return;
    schedulePriceUpdateFromEl(t);
  }, true);

  document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".ff-frame-picker").forEach((pickerEl) => {
    const sectionEl = findMainSectionFromEl(pickerEl);
    const form = getProductFormFromSection(sectionEl);
    if (!form) return;

    // første render
    updateMainPriceFromSelection(sectionEl);

    // når Dawn skifter variant (størrelse), ændres input[name="id"]
    const idInput = form.querySelector('input[name="id"]');
    if (!idInput) return;

    const obs = new MutationObserver(() => {
      // Dawn kan ændre value meget hurtigt – giv den et tick
      setTimeout(() => updateMainPriceFromSelection(sectionEl), 0);
    });

    obs.observe(idInput, { attributes: true, attributeFilter: ["value"] });
  });
});

  // --- Submit: add poster + frame (2 items) ---
  document.addEventListener("submit", async (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.closest("product-form")) return;

    const sectionEl = findMainSectionFromEl(form);
    const pickerEl = getPickerFromSection(sectionEl);
    if (!pickerEl) return;

    const select = pickerEl.querySelector('select[name="ff_frame_select"]');
    const value = select ? select.value : "none";
    if (!value || value === "none") return; // normal Dawn add-to-cart (poster only)

    e.preventDefault();

    const handles = JSON.parse(pickerEl.dataset.ffFrameHandles || "{}");
    const frameHandle = handles[value];
    if (!frameHandle) return;

    const frameLabel = select.options[select.selectedIndex]?.text || value;

    if (form.dataset.ffBundling === "1") return;
    form.dataset.ffBundling = "1";

    const btn = form.querySelector('button[type="submit"]');
    btn?.setAttribute("aria-disabled", "true");

    try {
      await addBundleToCart({ sectionEl, frameHandle, frameLabel });
    } catch (err) {
      alert(err.message || "Kunne ikke lægge plakat + ramme i kurven.");
    } finally {
      btn?.removeAttribute("aria-disabled");
      delete form.dataset.ffBundling;
    }
  }, true);
})();
